__turbopack_context__.v({
  "className": "roboto_99ca6e98-module__VG7d8G__className",
  "variable": "roboto_99ca6e98-module__VG7d8G__variable",
});
